import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import { Alert } from '@mui/material';


import { registerToApp } from '../Commons/FirebaseAuthService';
import Copyright from "../Commons/Copyright"

export default function SignUp() {
  let [error, setError] = React.useState('');
  let navigate = useNavigate();
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    if (data.get('password') !== data.get('confirmPassword')){
      setError('Password and Confirm Password does not match.')
    }
    else{
      setError('');
      registerToApp(data.get('email'), data.get('password'))
      .then(([signUpSuccess, response]) => {
        if(signUpSuccess){
          alert("Successfully registered. Now Sign in using the credentials.");
          navigate('/');
        }
        else{
          setError(response.message);
        }
      })
      
    }
  };

  let errorDisplay = <></>;
  if(error !== ''){
    errorDisplay = <Alert severity="error">{error}</Alert>
  }
  
  return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign Up
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="enter-password"
              // error={error !== ''}
              // helperText={error}
            />
             <TextField
              margin="normal"
              required
              fullWidth
              name="confirmPassword"
              label="Confirm Password"
              type="password"
              id="cnfmPassword"
              autoComplete="confirm-password"
              // error={error !== ''}
              // helperText={error}

            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign Up
            </Button>
            <Grid container>
              <Grid item>
                <Link to="/" variant="body2">
                  {"Already have an account? Sign In"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box>
        {errorDisplay}
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
  );
}